import config from 'config';

const LOAD = 'horse-racing/early-entries/LOAD';
const LOAD_SUCCESS = 'horse-racing/early-entries/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/early-entries/LOAD_FAIL';

const initialState = {
  loading: false,
  loaded: false,
  earlyEntries: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        earlyEntries: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading({ horseRacing : { earlyEntries: { loading = false } = {} } = {} } = {}) {
  return loading;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.horseRacing.loadMeeting}`, { params: { earlyEntry: true } })
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/earlyEntries.js